import React, { useState } from "react";
import { Form, Button, Spinner, Col, Row, Container } from "react-bootstrap";
import { api_paths } from "../config/api.paths";
import API from "../config/axios";
import { toastErrorMessage, toastSuccessMessage } from "../utils/utils";
import { changePasswordSchema } from "../validators/validatorSchema";
import { validateData, clearError } from "../validators/YupValidations";
import { useNavigate } from "react-router-dom";
import { SET_LOADING } from "../redux/user";
import { useDispatch, useSelector } from "react-redux";
import LeftArrow from "../assets/images/committee/ArrowLeft.svg";

// ⬆️ Reusable Field Wrapper (same as Edit Profile)
const Field = ({ label, required, children, error }) => (
  <div className="mb-3 pb-1">
    <label className="form-label small mb-2">
      {label} {required && <span className="text-danger">*</span>}
    </label>

    {children}

    {error && <div className="text-danger small mt-1">{error}</div>}
  </div>
);

function ChangePassword() {
  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});
  const { loading } = useSelector((state) => state.USER_DATA);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });

    if (errors[field]) clearError(setErrors, field); // clear field error
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = await validateData(changePasswordSchema, form, setErrors);
    if (!isValid) return;

    try {
      dispatch(SET_LOADING(true));

      const res = await API.post(api_paths.member.CHANGE_PASSWORD, {
        old_password: form.old_password,
        new_password: form.new_password,
        confirm_password: form.confirm_password,
      });

      toastSuccessMessage(
        res.data?.message || "Password updated successfully!"
      );

      navigate(-1);

      setForm({
        old_password: "",
        new_password: "",
        confirm_password: "",
      });
    } catch (error) {
      toastErrorMessage(
        error.response?.data?.message || "Failed to update password."
      );
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  return (
    <Container>
      <Row>
        <Col lg={12} className="mb-4">
          <div className="py-4">
            <div className="d-flex mb-4 ">
              <img
                className="cursor-pointer"
                src={LeftArrow}
                alt="back-arrow"
                onClick={() => {
                  navigate(-1);
                }}
              />
              <h4 className="fw-bold text-main f-20 ms-3 mb-0">
                Change Password
              </h4>
            </div>
            <div className="changepassword-form p-4">
              <Row>
                <Col lg={6} className="mb-4">
                  <Form onSubmit={handleSubmit}>
                    {/* OLD PASSWORD */}
                    <Field
                      label="Old Password"
                      required
                      error={errors.old_password?.message}
                    >
                      <Form.Control
                        type="password"
                        placeholder="Enter Old Password"
                        value={form.old_password}
                        onChange={(e) =>
                          handleChange("old_password", e.target.value)
                        }
                        className={errors.old_password ? "is-invalid" : ""}
                      />
                    </Field>

                    {/* NEW PASSWORD */}
                    <Field
                      label="New Password"
                      required
                      error={errors.new_password?.message}
                    >
                      <Form.Control
                        type="password"
                        placeholder="Enter New Password"
                        value={form.new_password}
                        onChange={(e) =>
                          handleChange("new_password", e.target.value)
                        }
                        className={errors.new_password ? "is-invalid" : ""}
                      />
                    </Field>

                    {/* CONFIRM PASSWORD */}
                    <Field
                      label="Confirm Password"
                      required
                      error={errors.confirm_password?.message}
                    >
                      <Form.Control
                        type="password"
                        placeholder="Enter Confirm Password"
                        value={form.confirm_password}
                        onChange={(e) =>
                          handleChange("confirm_password", e.target.value)
                        }
                        className={errors.confirm_password ? "is-invalid" : ""}
                      />
                    </Field>

                    <Button
                      type="submit"
                      className="btn btn-orange-lg"
                      disabled={loading}
                    >
                      {loading ? <Spinner size="sm" /> : "Update"}
                    </Button>
                  </Form>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ChangePassword;
